import { useMutation } from '@tanstack/react-query'
import SessionConfig from '../../model/SessionConfig'
import { paymentService } from '../../service/domain/_service.config'
import { PassType, TeamData } from '../../service/domain/PaymentService'

export interface CreateCheckoutSessionInput {
  passType: PassType
  config: SessionConfig
  successUrl: string
  cancelUrl: string
  challengeId: string
  teamData?: TeamData
  teamId?: string
  actionType?: string
}

export function useCreateCheckoutSession() {
  return useMutation({
    mutationFn: async (input: CreateCheckoutSessionInput) => {
      return paymentService.createCheckoutSession(
        input.passType,
        input.config,
        input.successUrl,
        input.cancelUrl,
        input.challengeId,
        input.teamData,
        input.teamId,
        input.actionType,
      )
    },
  })
}
